import styled from 'styled-components'

// The app applies styled-reset globally, which strips list markers, heading
// sizes and block margins. Markdown output needs them back, so this restores
// only what the reset removed - everything else is left to the global styles.
//
// Spacing is set with margins on the block elements rather than a flex gap on
// this wrapper: the library nests blocks inside a wrapper of its own for
// multi-block content and omits it for a single line, and inline runs such as
// <strong> must not become rows of their own.
export const ConversationMarkdownStyled = styled.div`
  p,
  ul,
  ol,
  table,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 ${(props) => props.theme.space.small};
  }

  > *:last-child,
  > * > *:last-child {
    margin-bottom: 0;
  }

  ul,
  ol {
    padding-left: ${(props) => props.theme.typography.pxToRem(20)};
  }

  ul {
    list-style: disc outside;
  }

  ol {
    list-style: decimal outside;
  }

  li {
    display: list-item;
  }

  li ul {
    list-style: circle outside;
  }

  /* The reset clears it and the global styles only restore <i>. */
  em {
    font-style: italic;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: ${(props) => props.theme.fontWeights.bold};
  }

  h1 {
    font-size: ${(props) => props.theme.typography.pxToRem(20)};
  }

  h2 {
    font-size: ${(props) => props.theme.typography.pxToRem(18)};
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
  }

  th,
  td {
    padding: ${(props) => props.theme.space.small};
    border: ${(props) => props.theme.typography.pxToRem(1)} solid
      ${(props) => props.theme.colors.content.border};
    text-align: left;
    vertical-align: top;
  }

  th {
    background: ${(props) => props.theme.colors.content.secondaryBackground};
  }
`
